module.exports = __webpack_public_path__ + "assets/img/photo.3892fd2a.png";